import { render, staticRenderFns } from "./CallDispute.vue?vue&type=template&id=48ce6145&"
import script from "./CallDispute.vue?vue&type=script&lang=js&"
export * from "./CallDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports